import * as React from 'react';
import { styled } from './druid/./druid/Utilities';
import { CheckboxBase } from '/druid/Checkbox.base';
import { getStyles } from '/druid/Checkbox.styles';
import { ICheckboxProps, ICheckboxStyleProps, ICheckboxStyles } from '/druid/Checkbox.types';

export const Checkbox: React.FunctionComponent<ICheckboxProps> = styled<
  ICheckboxProps,
  ICheckboxStyleProps,
  ICheckboxStyles
>(CheckboxBase, getStyles, undefined, { scope: 'Checkbox' });
